import { hideModal, showModal } from "global/context/action/modal/modal";
import { GlobalContext } from "global/context/Provider";
import { useContext, useEffect, useState } from "react";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import { PortalContext } from "_+_Portal/context/Provider";
import CardAtencionSinTurno from "_+_Portal/_-_Autocheckin/components/genericos/CardAtencionSinTurno/CardAtencionSinTurno";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import ModalTurnoParticular from "_+_Portal/_-_Autocheckin/components/genericos/ModalTurnoParticular/ModalTurnoParticular";
import {
  wsGetAtencionSinTurnoQr,
  wsGetVerificarOsAtencionSinTurnoQr,
  wsPostTomarAtencionSinTurnoQr,
} from "_+_Portal/_-_Autocheckin/context/action/atencionSinTurno";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { setTurnoForced } from "_+_Portal/_-_Autocheckin/context/action/turnosAutoCheckIn";
import { setTurnosSeleccionado } from "_+_Portal/_-_Autocheckin/context/action/turnosSeleccionados";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";

import { ContainerAtencionSinTurno } from "./localStyle";
import { showToaster } from "global/context/action/toaster/toaster";

const AtencioSinTurno = ({ setError }) => {
  // -------------------------  context ----------------------------

  const {
    atencionSinTurnoDispatch,
    turnosSeleccionadosDispatch,
    turnosAutoCheckInDispatch,
    pasoDispatch,
  } = useContext(AutocheckContext);
  const { authState, modalDispatch, toasterDispatch } =
    useContext(GlobalContext);
  const { selectDropDownState } = useContext(PortalContext);
  // -------------------------  context ----------------------------

  // -------------------------  useState ----------------------------
  const [turnos, setTurnos] = useState([]);
  const [loading, setLoading] = useState(true);
  // -------------------------  useState ----------------------------

  // -------------------------  constans ----------------------------
  let centroQR = sessionStorage.getItem("centroID");
  const idCentro = centroQR ? centroQR : "09";
  const pacienteNombre = selectDropDownState.selectDropDown.selectGlobal
    .pacienteElegido?.paciente?.nombre
    ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido?.paciente
        ?.nombre
    : authState?.auth?.data?.paciente?.nombre;

  // -------------------------  constans ----------------------------

  // -------------------------  useEffect ----------------------------
  useEffect(() => {
    wsGetAtencionSinTurnoQr(
      idCentro,
      nextStepGetTurnos
    )(atencionSinTurnoDispatch);
  }, []);
  // -------------------------  useEffect ----------------------------

  // -------------------------  funtions ----------------------------
  const nextStepGetTurnos = (isCorrect, data) => {
    if (isCorrect) {
      setLoading(false);
      setTurnos(data);
    } else {
      setError({
        message: data ? data : "Error al tomar turnos",
        errorBack: "Home",
      });
      setPaso("ModalErrorAutoT")(pasoDispatch);
    }
  };

  const handleClickElement = (turno) => {
    let dissmiss = () => {
      hideModal()(modalDispatch);
    };
    let nextStep = (isCorrect, data) => {
      setLoading(true);
      if (isCorrect) {
        if (data.codigo === 91) {
          setLoading(false);
          showModal(
            <ModalTurnoParticular
              tomarTurno={() => finalizarProyecto(turno, false, true)}
              mensajeError={data.mensaje}
              osAlternativa={true}
            />,
            "La obra social no cubre",
            dissmiss,
            false,
            {},
            "centro",
            true
          )(modalDispatch);
        } else if (data.codigo === 9) {
          setLoading(false);
          showModal(
            <ModalTurnoParticular
              tomarTurno={() => finalizarProyecto(turno, true, false)}
              mensajeError={data.mensaje}
            />,
            "La obra social no cubre",
            dissmiss,
            false,
            {},
            "centro",
            true
          )(modalDispatch);
        } else {
          finalizarProyecto(turno);
        }
      } else {
        setLoading(false);
        showToaster(
          {
            texto: data !== "" ? data : "Ha ocurrido un error",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      }
    };
    setLoading(true);
    wsGetVerificarOsAtencionSinTurnoQr(
      turno.idMedico,
      turno.idEspe,
      nextStep
    )();
  };
  const finalizarProyecto = (turno, particular, osAlternativa) => {
    setLoading(true);
    let dto = {
      // idPaciente: paciente.codigo,
      idMedico: turno.idMedico,
      idEspecialidad: turno.idEspe,
      idCentro: turno.idCentro,
      particular,
      osAlternativa,
    };
    let nextStep = (isCorrect, element) => {
      if (isCorrect) {
        let turno = {
          idturno: element["idturno"],
          idMedico: element["idMedico"],
          idRecepcion: element["idRecepcion"],
          idCentro: element["idCentro"],
          medico: element["medico"],
          fecha: element["fecha"],
          hora: element["hora"],
          especialidad: element["especialidad"],
          centro: element["centro"],
          checkin: element["checkin"],
          flgSaldada: element["flgSaldada"],
          coordenadaGps: element["coordenadaGps"],
          selected: true,
          idProtocolo: element["idProtocolo"],
          presente: element["presente"],
          consultorio: element["consultorio"],
          flgSoloConsulta: element["flgSoloConsulta"],
          flgSoloPractica: element["flgSoloPractica"],
          ausente: element["ausente"],
          piso: element["piso"],
          requiereAutorizacion: element["requiereAutorizacion"],
          estadoProtocolo: element["estadoProtocolo"],
          kinesioVerificaRecepcion: element["kinesioVerificaRecepcion"],
          osValidacionInterna: element["osValidacionInterna"],
          idEspecialidad: element["idEspecialidad"],
          resumen: {
            validaOnlineEstado: element["validaOnlineEstado"],
            validaOnline: element["validaOnline"],
            monto: element["monto"],
            medSolicitanteDto: element["medSolicitanteDto"],
            estadoOrden: element["estadoOrden"],
            tieneDeterminaciones: element["tieneDeterminaciones"],
          },
        };
        setTurnosSeleccionado([turno])(turnosSeleccionadosDispatch);
        setTurnoForced([turno])(turnosAutoCheckInDispatch);
        setPaso("NumeroAfiliado")(pasoDispatch);
      } else {
        setError({
          message: "Error al traer el turno",
          errorBack: "Home",
        });
      }
      setLoading(false);
    };
    wsPostTomarAtencionSinTurnoQr(dto, nextStep)();
  };

  // -------------------------  funtions ----------------------------

  return (
    <>
      <Loading
        dataLoading={loading}
        descripcion="Cargando..."
        color={"c-white"}
      />
      <LayoutPasos
        handleClick={() => {
          setPaso("Home")(pasoDispatch);
        }}
        title={"atención sin turno"}
        subtitle={pacienteNombre}
      >
        <ContainerAtencionSinTurno>
          {turnos.map((element, index) => {
            return (
              <CardAtencionSinTurno
                key={index}
                sede={element.centro}
                profesional={element.profesional}
                demora={element.demora}
                onclick={() => {
                  handleClickElement(element);
                }}
              />
            );
          })}
        </ContainerAtencionSinTurno>
      </LayoutPasos>
    </>
  );
};

export default AtencioSinTurno;
